import { configureStore } from "@reduxjs/toolkit";
import accesSlice from "features/access";
import appRoleAssignmentReducer from "features/appRoleAssignments";
import archivalSettingsReducer from "features/archivalSettings";
import brandingSliceReducer from "features/branding";
import dashboardSlice from "features/dashboard";
import devicesAdapter from "features/devices";
import groupsReducer from "features/groups";
import hardwareApproversSlice from "features/hardware/hardwareApprovers";
import hardwareBundles from "features/hardware/hardwareBundles";
import hardwarePage from "features/hardware/hardwarePage";
import licenseAssignmentErrorsReducer from "features/licenses/licenseAssignmentErrors";
import lockedDialogReducer from "features/lockedDialog";
import notificationCenterReducer from "features/notificationCenter";
import notificationsReducer from "features/notifications";
import officeDataSlice from "features/officeData";
import ordersReducer from "features/orders";
import recommendationsReducer from "features/recommendations";
import reportsSlice from "features/reports";
import rolesReducer from "features/roles";
import secureScoreSlice from "features/secureScore";
import setupDialogSlice from "features/setupDialog";
import signInsSlice from "features/signins";
import snackbarSliceReducer from "features/snackbars";
import ticketStatisticsSlice from "features/tickets/ticketStatistics";
import userDrawerReducer from "features/user";
import aggregatedDataReducer from "./features/aggregatedData";
import costsReducer from "./features/costs";
import customerReducer from "./features/customer";
import departmentsReducer from "./features/departments";
import entitlementsReducer from "./features/entitlements";
import productsReducer from "./features/hardware/products";
import invoiceReducer from "./features/invoices";
import licenseNamesReducer from "./features/licenses/licenseNames";
import licensePricesReducer from "./features/licenses/licensePrices";
import licensesReducer from "./features/licenses/licenses";
import mailDomainsReducer from "./features/mailDomains";
import requesterReducer from "./features/requesters";
import scheduledActionsReducer from "./features/scheduledActions";
import serviceStatusReducer from "./features/serviceStatuses";
import securityIncidentReducer from "./features/tickets/securityIncidents";
import usersReducer from "./features/users";

export const store = configureStore({
	reducer: {
		products: productsReducer,
		mailDomains: mailDomainsReducer,
		departments: departmentsReducer,
		entitlements: entitlementsReducer,
		licenses: licensesReducer,
		licensePrices: licensePricesReducer,
		licenseNames: licenseNamesReducer,
		licenseAssignmentErrors: licenseAssignmentErrorsReducer,
		scheduledActions: scheduledActionsReducer,
		recommendations: recommendationsReducer,
		groups: groupsReducer,
		users: usersReducer,
		customer: customerReducer,
		requesters: requesterReducer,
		costs: costsReducer,
		invoices: invoiceReducer,
		aggregatedData: aggregatedDataReducer,
		securityIncidents: securityIncidentReducer,
		serviceStatuses: serviceStatusReducer,
		appRoleAssignments: appRoleAssignmentReducer,
		archivalSettings: archivalSettingsReducer,
		roles: rolesReducer,
		orders: ordersReducer,
		hardwareBundles: hardwareBundles,
		hardwarePage: hardwarePage,
		hardwareApprovers: hardwareApproversSlice,
		lockedDialog: lockedDialogReducer,
		devices: devicesAdapter,
		userDrawer: userDrawerReducer,
		branding: brandingSliceReducer,
		snackbar: snackbarSliceReducer,
		access: accesSlice,
		reports: reportsSlice,
		dashboard: dashboardSlice,
		ticketStatistics: ticketStatisticsSlice,
		signins: signInsSlice,
		officeData: officeDataSlice,
		secureScore: secureScoreSlice,
		setupDialog: setupDialogSlice,
		notifications: notificationsReducer,
		notificationCenter: notificationCenterReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore these action types
				ignoredActions: ["invoices/fetch/fulfilled"],
			},
		}),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
